module.exports = {"serverURL":"https://www.bain.com/","socialMediaIconsTitle":"How far is your company on its digital journey? Take Bain’s Digital Readiness Assessment","socialMediaIconsDomain":"www.bain.com","emailId":"","industries":["Consumer Products","Retail","Financial Services","Healthcare","Advanced Manufacturing & Services","Energy & Natural Resources","Technology","Media","Telecom","Other"]}


//////////////////
// WEBPACK FOOTER
// ./src/config.json
// module id = 459
// module chunks = 0